import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { CartConfigService, CartService, CartRow,BaseViewConfigService, ProductAssortmentParentService } from 'gung-standard';
import { CarLinerSalesCartListComponent } from '../components/car-liner-sales-cart-list/car-liner-sales-cart-list.component';

@Injectable({
  providedIn: 'root'
})
export class CarLinerCartConfigService extends CartConfigService {
  constructor(protected cartService: CartService,
    protected baseViewConfigService: BaseViewConfigService,
    protected productAssortmentParentService: ProductAssortmentParentService) {
    super(cartService, baseViewConfigService, productAssortmentParentService);
  }

  getLayouts(): ListLayout<CartRow>[] {
    return [
      {
        getIconClass: () => '',
        getName: () => 'Cart grid',
        getListItemComponent: () => CarLinerSalesCartListComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent
      }
    ];
  }
}
